<template>
  <div class="conference">
    <v-container class="my-5">
      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-card class="ma-3">
            <v-card-text class="mt-5">
                <h2 class="font-weight-bold mb-2">{{ conference }} {{ conference !== 'ACC' ? division1[0].division : null}}</h2>
              <v-divider class="mb-6"/>
              <v-radio-group v-model="conferencePicks[conference].division1Winner">
                <v-radio
                  :color="n.color"
                  v-for="n in division1"
                  :key="n.school"
                  :label="`${n.school}`"
                  :value="n.school"
                  @change="selectTeam(conference, 'division1', n.school)"
                ></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md4 v-if="division2">
          <v-card class="ma-3">
            <v-card-text class="mt-5">
                  <h2 class="font-weight-bold mb-2">{{ conference }} {{ division2[0].division}}</h2>
              <v-divider class="mb-6"/>
              <v-radio-group v-model="conferencePicks[conference].division2Winner">
                <v-radio
                  :color="n.color"
                  v-for="n in division2"
                  :key="n.school"
                  :label="`${n.school}`"
                  :value="n.school"
                  @change="selectTeam(conference, 'division2', n.school)"
                ></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md4 v-if="conferencePicks[conference].division1Winner && conferencePicks[conference].division2Winner">
          <v-card class="ma-3">
            <v-card-text class="mt-5">
                  <h2 class="font-weight-bold mb-2">{{ conference }} Champion</h2>
              <v-divider class="mb-6"/>
              <v-radio-group v-model="conferencePicks[conference].conferenceChampion">
                <v-radio
                  color="primary"
                  :label="`${conferencePicks[conference].division1Winner}`"
                  :value="`${conferencePicks[conference].division1Winner}`"
                  @change="selectChampion(conference, conferencePicks[conference].division1Winner)"
                ></v-radio>
                <v-radio
                  color="primary"
                  :label="`${conferencePicks[conference].division2Winner}`"
                  :value="`${conferencePicks[conference].division2Winner}`"
                  @change="selectChampion(conference, conferencePicks[conference].division2Winner)"
                ></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "Conference",
  props: ["name"],
  data() {
    return {
      divisions: []
    };
  },
  methods: {
    selectTeam(conf, div, team) {
        this.conferencePicks[conf][div+'Winner'] = team
        this.$store.dispatch('updateConferencePicks', this.conferencePicks)
    },
    selectChampion(conference, team) {
        this.conferencePicks[conference].conferenceChampion = team
        this.$store.dispatch('updateConferencePicks', this.conferencePicks)
    }
  },
  created() {
    const groupByKey = this.conference === "ACC" ? "conference" : "division"
    this.divisions = _.groupBy(
      this.allTeams.filter(x => x.conference === this.$props.name),
      groupByKey
    ),
    this.$store.dispatch('fetchConferencePicks')
  },
  computed: {
    ...mapState(["allTeams"]),
    ...mapGetters(["conferencePicks"]),
    division1() {
      let divisionTeams = this.divisions[Object.keys(this.divisions)[0]];
      if(this.conference === "ACC"){
        const notreDame = this.allTeams.filter(x => x.id === 87)[0]
        divisionTeams.push(notreDame)
      }
      console.log(divisionTeams)
      return _.sortBy(divisionTeams, ['school'])
    },
    division2() {
      return this.divisions[Object.keys(this.divisions)[1]];
    },
    conference() {
        return this.$props.name
    }
  }
};
</script>